import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { hcApi, getHcToken, setHcToken } from './api';

const Ctx = createContext(null);

export const HelpConnectAuthProvider = ({ children }) => {
  const [me, setMe] = useState(getHcToken() ? null : false);

  const loadMe = useCallback(async () => {
    if (!getHcToken()) return setMe(false);
    try {
      const { data } = await hcApi.get('/me');
      setMe(data);
    } catch {
      setHcToken(null);
      setMe(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const signIn = async (token) => {
    setHcToken(token);
    setMe(null);
    await loadMe();
  };

  const signOut = () => {
    setHcToken(null);
    setMe(false);
  };

  return <Ctx.Provider value={{ me, signIn, signOut }}>{children}</Ctx.Provider>;
};

export const useHelpConnect = () => useContext(Ctx);

export const HcLoading = () => (
  <div className="hc-root min-h-screen flex items-center justify-center bg-white" data-testid="hc-loading">
    <Loader2 className="w-8 h-8 animate-spin text-[#922A8C]" />
  </div>
);

export const HcProtected = ({ children }) => {
  const { me } = useHelpConnect();
  const loc = useLocation();
  if (me === null) return <HcLoading />;
  if (!me) return <Navigate to="/helpconnect/login" replace state={{ from: loc.pathname }} />;
  return children;
};

export const HcPublicOnly = ({ children }) => {
  const { me } = useHelpConnect();
  if (me === null) return <HcLoading />;
  if (me) return <Navigate to="/helpconnect" replace />;
  return children;
};
